module.exports = __webpack_public_path__ + "img/img_title1.770d2e95.png";